<template>
<div class="chapter">
<div class="inner_page">
<p class="pt"><a id="page_27"></a><a href="#/xhtml/07_Contents#pt1" id="pt1"><b><span class="small">PART I</span></b></a></p>
<p class="fig"><img alt="image" src="images/line1.jpg"/></p>
<p class="pr"><a href="#/xhtml/07_Contents#pt1">Redrawing the Boundaries</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Part01.vue?81721cc6